import { Order, OrderItem } from '@/types/api/order';
import { OrderListItem } from '../components/order-list';

export function calculateTotalQuantity(orderItems: Array<OrderItem>): number {
  return orderItems.reduce((acc, cur) => acc + cur.quantity, 0);
}

export const orderToListItem = (order: Order): OrderListItem => ({
  id: order.id,
  customer: `${order.customer.firstName} ${order.customer.lastName}`,
  itemCount: calculateTotalQuantity(order.orderItems),
  status: order.status,
  amount: order.totalAmount,
});
